/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { fireBoardCreateErrorAnalytics } from './fireBoardCreateErrorAnalytics.tsx';
import { BoardCreateFlyoutMenu } from './BoardCreateFlyoutMenu.tsx';
import type { BoardCreateProps } from './BoardCreateProps.types.tsx';

export const BoardCreate = ({
	projectId,
	projectAvatar,
	renderTrigger,
	triggerRef,
}: BoardCreateProps): React.JSX.Element | null => {
	if (!projectId) {
		fireBoardCreateErrorAnalytics({
			error: new Error('Failed to load board create flyout menu: projectId undefined'),
			attributes: {
				projectId,
			},
			id: 'loadFlyoutMenu',
		});

		return null;
	}

	return (
		<BoardCreateFlyoutMenu
			renderTrigger={renderTrigger}
			projectId={projectId}
			projectAvatar={projectAvatar}
			triggerRef={triggerRef}
		/>
	);
};
